<template v-if="product" >
  <div v-if="category.ProductID" class="item" style="cursor:pointer" @click="showModal">
    <div :class="{ 'with-image': getProductImage(product) }" class="item-details">
      <h5 class="item-title">{{ category.Name }}</h5>
      <p
        :title="product.ShortDescription"
        class="block-with-text"
        v-html="product.ShortDescription"
      ></p>
    </div>
    <div class="item-price d-flex">
      <h5 v-if="category.Price > 0">{{ category.Price | formatMoney(currencySign) }}</h5>
      <ul>
        <li
          v-for="(dietary, index) in dietaryList"
          :key="index"
          :style="getIconStyle(dietary)"
          :title="dietary.Name"
        ></li>
      </ul>
    </div>
    <div
      v-lazy:background-image="getProductImage(product)"
      :style="imageRatioStyle"
      class="item-img"
    />
    <img
      v-lazy="getProductImage(product)"
      style="display:none"
      class="item-img"
      @error="imgHttpError"
      alt="productImage"
    />
    <div
      :class="{
        new: product.Status === 1,
        popular: product.Status === 2,
        sold: product.Status === 3
      }"
      class="ibadge"
    >{{ formatStatus(product.Status , this) }}</div>
    <AddToCart
      v-if="isModalVisible"
      :price="category.Price"
      :category="category"
      :parent-category="parentCategory"
      :product="product"
      :modifiers="modifiers"
      :image-styles="dialogImageRatioStyle"
    />
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/products/Product.js";
import AddToCart from "./AddToCart.vue";
export default {
  name: "Product",
  components: {
    AddToCart,
  },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    sectionId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0
    };
  },
  computed: {
    ...shared.computed
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
    getProductImage(product) {
      if (product.PhotoUrl) return product.PhotoUrl;
      else return null;
    }
  }
};
</script>
